import React, { useEffect, useState } from 'react';
import './FormularioChoferes.css';
import { ChoferesService } from '../services/choferesService';

const FormularioChoferes = () => {
  const [choferes, setChoferes] = useState([]);
  const [mostrarFormulario, setMostrarFormulario] = useState(true);
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState('');
  const [exito, setExito] = useState('');
  const [choferEditando, setChoferEditando] = useState(null);

  const [filtros] = useState({
    query: '',
    estado: 'todos'
  });

  // Campos del formulario de choferes
  const [form, setForm] = useState({
    nombre: '',
    apellido: '',
    edad: '',
    numeroSeguroSocial: '',
    contactoEmergencia: '',
    numeroTelefono: '',
    domicilio: '',
    tipoSangre: '',
    tipoLicencia: '',
    fechaVigencia: '',
    estado: 'activo'
  });

  useEffect(() => {
    const unsubscribe = ChoferesService.suscribirseChoferes(setChoferes);
    return () => {
      if (typeof unsubscribe === 'function') unsubscribe();
    };
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setExito('');

    // Validaciones
    if (!form.nombre || !form.apellido || !form.edad || !form.numeroTelefono || !form.domicilio) {
      setError('Completa todos los campos requeridos');
      return;
    }

    if (!/^\d+$/.test(form.edad) || parseInt(form.edad) < 18 || parseInt(form.edad) > 70) {
      setError('La edad debe ser un número entre 18 y 70 años');
      return;
    }

    if (!/^\d{10}$/.test(form.numeroTelefono.replace(/\D/g, ''))) {
      setError('El número de teléfono debe tener 10 dígitos');
      return;
    }

    if (form.numeroSeguroSocial && !/^\d{11}$/.test(form.numeroSeguroSocial.replace(/\D/g, ''))) {
      setError('El número de seguro social debe tener 11 dígitos');
      return;
    }

    try {
      setCargando(true);
      console.log('FormularioChoferes: Iniciando guardado de chofer...', form);
      
      const dataAGuardar = {
        nombre: form.nombre.trim(),
        apellido: form.apellido.trim(),
        edad: parseInt(form.edad, 10),
        numeroSeguroSocial: form.numeroSeguroSocial.trim() || null,
        contactoEmergencia: form.contactoEmergencia.trim() || null,
        numeroTelefono: form.numeroTelefono.replace(/\D/g, ''),
        domicilio: form.domicilio.trim(),
        tipoSangre: form.tipoSangre || null,
        tipoLicencia: form.tipoLicencia || null,
        fechaVigencia: form.fechaVigencia || null,
        estado: form.estado
      };

      console.log('FormularioChoferes: Datos a guardar:', dataAGuardar);

      if (choferEditando) {
        console.log('FormularioChoferes: Actualizando chofer existente...', choferEditando.id);
        await ChoferesService.actualizarChofer(choferEditando.id, dataAGuardar);
        setExito('Chofer actualizado correctamente');
        console.log('FormularioChoferes: Chofer actualizado exitosamente');
      } else {
        console.log('FormularioChoferes: Creando nuevo chofer...');
        const choferId = await ChoferesService.crearChofer(dataAGuardar);
        setExito('Chofer registrado correctamente');
        console.log('FormularioChoferes: Chofer creado exitosamente con ID:', choferId);
      }

      // Limpiar formulario
      setForm({
        nombre: '',
        apellido: '',
        edad: '',
        numeroSeguroSocial: '',
        contactoEmergencia: '',
        numeroTelefono: '',
        domicilio: '',
        tipoSangre: '',
        tipoLicencia: '',
        fechaVigencia: '',
        estado: 'activo'
      });
      setChoferEditando(null);
      
      // Ocultar el formulario después de guardar exitosamente
      setMostrarFormulario(false);
    } catch (err) {
      console.error('FormularioChoferes: Error al guardar chofer:', err);
      setError(`Error al guardar el chofer: ${err.message || 'Error desconocido'}`);
    } finally {
      setCargando(false);
    }
  };

  const comenzarEdicion = (chofer) => {
    setChoferEditando(chofer);
    setMostrarFormulario(true);
    setForm({
      nombre: chofer.nombre || '',
      apellido: chofer.apellido || '',
      edad: String(chofer.edad || ''),
      numeroSeguroSocial: chofer.numeroSeguroSocial || '',
      contactoEmergencia: chofer.contactoEmergencia || '',
      numeroTelefono: chofer.numeroTelefono || '',
      domicilio: chofer.domicilio || '',
      tipoSangre: chofer.tipoSangre || '',
      tipoLicencia: chofer.tipoLicencia || '',
      fechaVigencia: chofer.fechaVigencia || '',
      estado: chofer.estado || 'activo'
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const cancelarEdicion = () => {
    setChoferEditando(null);
    setForm({
      nombre: '',
      apellido: '',
      edad: '',
      numeroSeguroSocial: '',
      contactoEmergencia: '',
      numeroTelefono: '',
      domicilio: '',
      tipoSangre: '',
      tipoLicencia: '',
      fechaVigencia: '',
      estado: 'activo'
    });
  };

  const eliminarChofer = async (chofer) => {
    if (!window.confirm(`¿Eliminar el chofer ${chofer.nombre} ${chofer.apellido}?`)) return;
    try {
      await ChoferesService.eliminarChofer(chofer.id);
    } catch (err) {
      console.error(err);
      alert('No se pudo eliminar el chofer');
    }
  };

  return (
    <div className='FormularioChoferes'>
      <div className='header-section'>
        <h1>Registro de Choferes</h1>
        {!mostrarFormulario && (
          <button className='btn-primary' onClick={() => setMostrarFormulario(true)}>
            Registrar Nuevo Chofer
          </button>
        )}
      </div>

      {mostrarFormulario && (
        <form className='form-choferes' onSubmit={handleSubmit}>
          {/* Sección 1: Información Personal */}
          <div className='form-section'>
            <h3 className='form-section-title'>Información Personal</h3>
            <div className='form-grid'>
              <div className='form-row'>
                <label>Nombre *</label>
                <input 
                  name='nombre' 
                  value={form.nombre} 
                  onChange={handleChange} 
                  placeholder='Nombre del chofer' 
                  required 
                />
              </div>
              <div className='form-row'>
                <label>Apellido *</label>
                <input 
                  name='apellido' 
                  value={form.apellido} 
                  onChange={handleChange} 
                  placeholder='Apellido del chofer' 
                  required 
                />
              </div>
              <div className='form-row'>
                <label>Edad *</label>
                <input 
                  name='edad' 
                  type='number'
                  value={form.edad} 
                  onChange={handleChange} 
                  placeholder='25' 
                  min='18'
                  max='70'
                  required 
                />
              </div>
              <div className='form-row'>
                <label>Número de Seguro Social</label>
                <input 
                  name='numeroSeguroSocial' 
                  value={form.numeroSeguroSocial} 
                  onChange={handleChange} 
                  placeholder='12345678901' 
                  maxLength='11'
                />
              </div>
            </div>
          </div>

          {/* Sección 2: Información de Contacto */}
          <div className='form-section'>
            <h3 className='form-section-title'>Información de Contacto</h3>
            <div className='form-grid'>
              <div className='form-row'>
                <label>Número de Teléfono *</label>
                <input 
                  name='numeroTelefono' 
                  value={form.numeroTelefono} 
                  onChange={handleChange} 
                  placeholder='1234567890' 
                  maxLength='10'
                  required 
                />
              </div>
              <div className='form-row'>
                <label>Contacto de Emergencia</label>
                <input 
                  name='contactoEmergencia' 
                  value={form.contactoEmergencia} 
                  onChange={handleChange} 
                  placeholder='Nombre y teléfono del contacto' 
                />
              </div>
              <div className='form-row full-width'>
                <label>Domicilio *</label>
                <textarea 
                  name='domicilio' 
                  value={form.domicilio} 
                  onChange={handleChange} 
                  placeholder='Dirección completa del domicilio' 
                  rows='3'
                  required 
                />
              </div>
            </div>
          </div>

          {/* Sección 3: Información Médica y Licencia */}
          <div className='form-section'>
            <h3 className='form-section-title'>Información Médica y Licencia</h3>
            <div className='form-grid'>
              <div className='form-row'>
                <label>Tipo de Sangre</label>
                <select name='tipoSangre' value={form.tipoSangre} onChange={handleChange}>
                  <option value=''>Seleccionar tipo de sangre...</option>
                  <option value='A+'>A+</option>
                  <option value='A-'>A-</option>
                  <option value='B+'>B+</option>
                  <option value='B-'>B-</option>
                  <option value='AB+'>AB+</option>
                  <option value='AB-'>AB-</option>
                  <option value='O+'>O+</option>
                  <option value='O-'>O-</option>
                </select>
              </div>
              <div className='form-row'>
                <label>Tipo de Licencia</label>
                <select name='tipoLicencia' value={form.tipoLicencia} onChange={handleChange}>
                  <option value=''>Seleccionar tipo de licencia...</option>
                  <option value='A'>Tipo A - Motocicletas</option>
                  <option value='B'>Tipo B - Automóviles</option>
                  <option value='C'>Tipo C - Camiones ligeros</option>
                  <option value='D'>Tipo D - Camiones pesados</option>
                  <option value='E'>Tipo E - Autobuses</option>
                </select>
              </div>
              <div className='form-row'>
                <label>Fecha de Vigencia de Licencia</label>
                <input 
                  type='date' 
                  name='fechaVigencia' 
                  value={form.fechaVigencia} 
                  onChange={handleChange} 
                />
              </div>
              <div className='form-row'>
                <label>Estado</label>
                <select name='estado' value={form.estado} onChange={handleChange}>
                  <option value='activo'>Activo</option>
                  <option value='inactivo'>Inactivo</option>
                  <option value='suspendido'>Suspendido</option>
                </select>
              </div>
            </div>
          </div>

          {/* Mensajes de error y éxito */}
          {error && (
            <div className='form-error' style={{
              backgroundColor: '#fee',
              color: '#c33',
              padding: '10px',
              borderRadius: '4px',
              margin: '10px 0',
              border: '1px solid #fcc'
            }}>
              <strong>Error:</strong> {error}
            </div>
          )}
          {exito && (
            <div className='form-success' style={{
              backgroundColor: '#efe',
              color: '#363',
              padding: '10px',
              borderRadius: '4px',
              margin: '10px 0',
              border: '1px solid #cfc'
            }}>
              <strong>Éxito:</strong> {exito}
            </div>
          )}

          {/* Botones de acción */}
          <div className='form-actions'>
            <button type='submit' className='btn-primary' disabled={cargando}>
              {cargando ? 'Guardando...' : (choferEditando ? 'Actualizar' : 'Guardar')}
            </button>
            {choferEditando ? (
              <button type='button' className='btn-secondary' onClick={cancelarEdicion}>
                Cancelar edición
              </button>
            ) : (
              <button type='button' className='btn-secondary' onClick={() => setMostrarFormulario(false)}>
                Cancelar
              </button>
            )}
          </div>
        </form>
      )}

      {/* Listado de Choferes */}
      <div className='listado-choferes'>
        <h2>Choferes registrados</h2>
        
        {/* Vista de tabla para desktop */}
        <div className='tabla-choferes-wrapper hidden-sm'>
          <table className='table-choferes'>
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Apellido</th>
                <th>Edad</th>
                <th>Teléfono</th>
                <th>Domicilio</th>
                <th>Tipo de Licencia</th>
                <th>Vigencia</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {choferes.length === 0 && (
                <tr><td colSpan={9} className='text-center text-muted'>Sin registros</td></tr>
              )}
              {choferes
                .filter((c) => {
                  const q = filtros.query.toLowerCase();
                  const coincideTexto =
                    !q ||
                    c.nombre?.toLowerCase().includes(q) ||
                    c.apellido?.toLowerCase().includes(q) ||
                    c.numeroTelefono?.includes(q);
                  const coincideEstado = filtros.estado === 'todos' || c.estado === filtros.estado;
                  return coincideTexto && coincideEstado;
                })
                .map((c) => (
                  <tr key={c.id}>
                    <td>{c.nombre}</td>
                    <td>{c.apellido}</td>
                    <td>{c.edad}</td>
                    <td>{c.numeroTelefono}</td>
                    <td className='domicilio-cell'>{c.domicilio}</td>
                    <td>{c.tipoLicencia || '—'}</td>
                    <td>{c.fechaVigencia || '—'}</td>
                    <td>
                      <span className={`estado-badge ${c.estado === 'activo' ? 'activo' : 'inactivo'}`}>
                        {c.estado === 'activo' ? 'Activo' : c.estado === 'suspendido' ? 'Suspendido' : 'Inactivo'}
                      </span>
                    </td>
                    <td>
                      <div className='acciones-tabla'>
                        <button className='btn-secondary' onClick={() => comenzarEdicion(c)}>Editar</button>
                        <button className='btn-secondary' onClick={() => eliminarChofer(c)}>Eliminar</button>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        {/* Vista de tarjetas para móviles */}
        <div className='mobile-card-view hidden-md'>
          {choferes.length === 0 && (
            <div className='text-center text-muted mt-2'>Sin registros</div>
          )}
          {choferes
            .filter((c) => {
              const q = filtros.query.toLowerCase();
              const coincideTexto =
                !q ||
                c.nombre?.toLowerCase().includes(q) ||
                c.apellido?.toLowerCase().includes(q) ||
                c.numeroTelefono?.includes(q);
              const coincideEstado = filtros.estado === 'todos' || c.estado === filtros.estado;
              return coincideTexto && coincideEstado;
            })
            .map((c) => (
              <div key={c.id} className='mobile-card'>
                <div className='mobile-card-header'>
                  <div className='mobile-card-title'>{c.nombre} {c.apellido}</div>
                  <span className={`estado-badge ${c.estado === 'activo' ? 'activo' : 'inactivo'}`}>
                    {c.estado === 'activo' ? 'Activo' : c.estado === 'suspendido' ? 'Suspendido' : 'Inactivo'}
                  </span>
                </div>
                <div className='mobile-card-content'>
                  <div className='mobile-card-field'>
                    <div className='mobile-card-label'>Edad</div>
                    <div className='mobile-card-value'>{c.edad} años</div>
                  </div>
                  <div className='mobile-card-field'>
                    <div className='mobile-card-label'>Teléfono</div>
                    <div className='mobile-card-value'>{c.numeroTelefono}</div>
                  </div>
                  <div className='mobile-card-field'>
                    <div className='mobile-card-label'>Domicilio</div>
                    <div className='mobile-card-value'>{c.domicilio}</div>
                  </div>
                  <div className='mobile-card-field'>
                    <div className='mobile-card-label'>Licencia</div>
                    <div className='mobile-card-value'>{c.tipoLicencia || '—'}</div>
                  </div>
                  <div className='mobile-card-field'>
                    <div className='mobile-card-label'>Vigencia</div>
                    <div className='mobile-card-value'>{c.fechaVigencia || '—'}</div>
                  </div>
                </div>
                <div className='mobile-card-actions'>
                  <button className='btn-secondary' onClick={() => comenzarEdicion(c)}>Editar</button>
                  <button className='btn-secondary' onClick={() => eliminarChofer(c)}>Eliminar</button>
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default FormularioChoferes;

